/**
 * WYSIWYG notation previews (team types, interaction modes, flow of change, annotation) for the
 * legend and the inspector. They reuse the renderer's palette glyphs, so chrome and palette always
 * show the same shapes. These are notation, not functional icons, so they stay outside Lucide.
 */

import {
  annotationIconSvg,
  flowIconSvg,
  interactionIconSvg,
  teamIconSvg,
} from "@miragon/team-topologies-renderer";
import type { InteractionMode, TeamType } from "@miragon/team-topologies-schema-model";

const PREVIEW_SIZE = 24;

function Glyph({ markup, size }: { markup: string; size: number }) {
  return (
    <span
      className="tt-shape-icon"
      style={{ width: size, height: size }}
      aria-hidden="true"
      // Static markup generated by our own renderer package from the notation spec.
      dangerouslySetInnerHTML={{ __html: markup }}
    />
  );
}

export function TeamIcon({ type, size = PREVIEW_SIZE }: { type: TeamType; size?: number }) {
  return <Glyph markup={teamIconSvg(type)} size={size} />;
}

export function InteractionIcon({
  mode,
  size = PREVIEW_SIZE,
}: {
  mode: InteractionMode;
  size?: number;
}) {
  return <Glyph markup={interactionIconSvg(mode)} size={size} />;
}

export function FlowIcon({ size = PREVIEW_SIZE }: { size?: number }) {
  return <Glyph markup={flowIconSvg()} size={size} />;
}

export function AnnotationIcon({ size = PREVIEW_SIZE }: { size?: number }) {
  return <Glyph markup={annotationIconSvg()} size={size} />;
}
